// extracted by mini-css-extract-plugin
export default {"welcomeContainer":"IntroSection_welcomeContainer__UZmhz","introductionPaper":"IntroSection_introductionPaper__ZVFLy"};